import { Cookie } from './storage'
const TOKEN_KEY = 'Authorization'
const ADDRESS_KEY = 'address'
const INFO_KEY = 'info'
// TOKEN

export const getToken = (): string | null => {
  // return Cookie.get(TOKEN_KEY)
  if (Local.get(TOKEN_KEY) !== 'undefined' && Local.get(TOKEN_KEY)) {
    return Local.get(TOKEN_KEY)
  }
  return Local.get('BMS-Authorization')
}

export const setToken = (v: string): void => {
  // Cookie.set(TOKEN_KEY, v, args)
  return Local.set(TOKEN_KEY, v)
}

export const removeToken = () => {
  Cookie.remove(TOKEN_KEY)
}

// address
export const getAddress = (): string => {
  return Cookie.get(ADDRESS_KEY) || ''
}

export const setAddress = (v: string, args?: object): void => {
  Cookie.set(ADDRESS_KEY, v, args)
}
export const removeAddress = () => {
  Cookie.remove(ADDRESS_KEY)
}

// info
export const getInfo = (): any => {
  // return Cookie.get(INFO_KEY) || ''
  return Local.get(INFO_KEY) || ''
}

export const setInfo = (v: string, args?: object): void => {
  // Cookie.set(INFO_KEY, v, args)
  Local.set(INFO_KEY, v)
}
export const removeInfo = () => {
  Cookie.remove(INFO_KEY)
}
export const setNetwork = (v: string, args?: object): void => {
  Cookie.set('Network', v, args)
}
